import { TYPE_CONVERSION, TYPE_POSTBACK } from 'scenes/Integrations/constants';

import {
  IntegrationConversionFormEdit,
  IntegrationConversionFormDuplicate,
} from './IntegrationConversionForm';
import {
  IntegrationPostbackFormEdit,
  IntegrationPostbackFormDuplicate,
} from './IntegrationPostbackForm';

export * from './IntegrationConversionForm';
export * from './IntegrationPostbackForm';

export const IntegrationFormEdit = ({ type, ...props }) => {
  if (type === TYPE_CONVERSION) {
    return <IntegrationConversionFormEdit {...props} />;
  }

  if (type === TYPE_POSTBACK) {
    return <IntegrationPostbackFormEdit {...props} />;
  }

  return null;
};

export const IntegrationFormDuplicate = ({ type, ...props }) => {
  if (type === TYPE_CONVERSION) {
    return <IntegrationConversionFormDuplicate {...props} />;
  }

  if (type === TYPE_POSTBACK) {
    return <IntegrationPostbackFormDuplicate {...props} />;
  }

  return null;
};
